export const commomText = {
  journeyApplication: "👶 #1 customized gifts app",
  capturemovement: "Capture the magic, relive the moment",
  momentjourney: `Our app transforms ordinary photos and customized gifts into interactive, living memories. Using the power of Augmented Reality, Padami lets you hide a world of emotion inside a single frame. Relive your most cherished memories anytime, anywhere.`,
  downloadAndroid: "Download for android ",
  downloadIos: "Download for IOS",
  tryApp: "Download the Padami App Free on iOS and Android!",
  ourmemories: "Padami is designed to be the ultimate keepsake, turning your home into a gallery of living memories. Start your magical journey today.",
};

export const links = {
  privacy_url: "https://www.sisulogs.com/privacy",
  instagram_url: "https://www.instagram.com/sisu_logs/profilecard/?igsh=MWNjY2IyaTB5NXQ0dA==",
  facebook_url: "https://www.facebook.com/share/ewZ62ANkfCYmoJX1/",
  pinterest_url: "https://in.pinterest.com/",
  youtube_url: "https://youtube.com/@sisulogs?si=ecvRRlASyAinCtt2",
  playstore_url: "https://play.google.com/store/apps/details?id=com.babydiaries",
  appstore_url: "https://apps.apple.com/us/app/sisu-logs-baby-memory-diary/id6745123098",
};
